import { IconName } from '@/config/icons'
import { BookingStep } from '@/lib/types/operations/booking'

/**
 * Defines the structure of each booking step
 */
export interface BookingStepConfig {
  id: BookingStep
  title: string
  icon: IconName
  description: string
}

/**
 * Defines the standard booking flow steps
 * Used for consistent step navigation throughout the booking process
 */
export const BOOKING_STEPS: BookingStepConfig[] = [
  {
    id: 'vehicle',
    title: 'Your Vehicle',
    icon: 'car',
    description: 'Tell us about your vehicle'
  },
  {
    id: 'services',
    title: 'Select Services',
    icon: 'wrench',
    description: 'Choose the services you need'
  },
  {
    id: 'schedule',
    title: 'Pick a Time',
    icon: 'calendar',
    description: 'Choose your preferred date and time'
  },
  {
    id: 'review',
    title: 'Review & Book',
    icon: 'check-circle',
    description: 'Review your booking and sign in to confirm'
  }
] as const
